import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problematicas } from './components/Problematicas';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Benefits } from './components/Benefits';
import { PurchaseSection } from './components/PurchaseSection';
import { Objections } from './components/Objections';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { RecentPurchasePopup } from './components/RecentPurchasePopup';
import { StickyCTA } from './components/StickyCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    const fbqScript = document.createElement('script');
    fbqScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbqScript);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      if (fbqScript.parentNode) document.head.removeChild(fbqScript);
      if (noscript.parentNode) document.body.removeChild(noscript);
    };
  }, []);
  return <div className="w-full min-h-screen bg-emerald-50" data-id="element-0">
      <Hero data-id="element-1" />
      <Problematicas data-id="element-2" />
      <Tomos data-id="element-3" />
      <Bonos data-id="element-4" />
      <Benefits data-id="element-5" />
      <PurchaseSection data-id="element-6" />
      <Objections data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
      <RecentPurchasePopup data-id="element-11" />
      <StickyCTA data-id="element-12" />
    </div>;
}